import Box from "@mui/material/Box";
import runwayLogoMain from "./runwayLogoMain.png";

// ==============================|| LOGO IMAGE ||============================== //

export default function LogoMain({ reverse }: { reverse?: boolean }) {
  return (
    <Box
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        component="img"
        src={runwayLogoMain}
        alt="Runway"
        sx={{ height: 60, display: "block" }}
      />
    </Box>
  );
}
